import { customerDeliveryDownloadListDetailService } from '@services/private/operation-history/customer-delivery/download-list-detail.service';
import { generateQueryString } from '../strings/shared-helpers-strings';
import { is200xRange } from '@utils/utilities';
import { updateState } from '../update-state';

type ListDataType = {
  page: number;
  size: number;
  sortName: string;
  sortType: string;
  schGroup: 'subject_filename' | 'remote_ip';
  schKeyword: string;
  adminConfigEnv: {
    cssJsVersion: string;
  } | null;
  otmHistDownloadList:
    | [
        {
          fileTotalCnt: number;
          fileTotalSize: number;
          histDt: string;
          histSeq: string;
          otmSubject: string;
          remoteIp: string;
        },
      ]
    | [];
  totalCount: number;
};

export const getCustomerDeliveryDownloadListDetail = async (
  listData: ListDataType,
  payload = [],
  stateSetter,
  fields,
) => {
  const { page, size, sortName, sortType, schGroup, schKeyword } = listData;

  const queryString = generateQueryString(
    [
      { key: 'page', value: page },
      { key: 'size', value: size },
      { key: 'sortName', value: sortName },
      { key: 'sortType', value: sortType },
      { key: 'schGroup', value: schGroup },
      { key: 'schKeyword', value: schKeyword },
    ].map((item) => {
      return fields.includes(item.key)
        ? payload.find((field) => {
            // @ts-ignore
            return field.key === item.key;
          })
        : item;
    }),
  );

  const { response, statusCode } =
    await customerDeliveryDownloadListDetailService(queryString);

  if (response?.code === '1' && is200xRange(statusCode)) {
    const list = [
      { key: 'adminConfigEnv', value: response?.result?.adminConfigEnv },
      {
        key: 'otmHistDownloadList',
        value: response?.result?.otmHistDownloadListInfo?.otmHistDownloadList,
      },
      {
        key: 'totalCount',
        value: response?.result?.otmHistDownloadListInfo?.totalCount,
      },
    ];

    payload.forEach((item) => {
      list.push(item);
    });

    updateState(list, stateSetter);
  }
};
